import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [usuario, setUsuario] = useState(null);

  // Recupera o estado de login do localStorage ao carregar
  useEffect(() => {
    const usuarioSalvo = localStorage.getItem("usuario");
    if (usuarioSalvo) {
      setIsLoggedIn(true);
      setUsuario(usuarioSalvo);
    }
  }, []);

  const login = (usuario, senha) => {
    // senhas e usuários para simulação
    const usuarioCorreto = "ited";
    const senhaCorreta = "123456";

    if (usuario === usuarioCorreto && senha === senhaCorreta) {
      setIsLoggedIn(true);
      setUsuario(usuario);
      localStorage.setItem("usuario", usuario);
      return { sucesso: true, mensagem: "Login realizado com sucesso!" };
    } else {
      return { sucesso: false, mensagem: "Usuário ou senha incorretos!" };
    }
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUsuario(null);
    localStorage.removeItem("usuario");
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
